<div class="w-100 position-relative vh-100 d-flex flex-column">
    <div class="py-4 d-flex w-100 justify-content-center">
        <img class="w-75 px-2 py-4 logo" src="public/logo_tim_enterprise.svg" alt="Logo Tim Enterprise" />
    </div>


    <!-- Gruppi Utente / Domini -->
    <app-user-groups></app-user-groups>

    <div class="w-100 mt-auto">
        <app-user-profile></app-user-profile>
    </div>
</div>
